import React, { Component } from 'react';
import { Link } from 'react-router-dom'
import { connect } from "react-redux";
import Divider from '@material-ui/core/Divider';
import withStyles from '@material-ui/core/styles/withStyles';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import Collapse from '@material-ui/core/Collapse';
import CircularProgress from '@material-ui/core/CircularProgress';
import IconButton from '@material-ui/core/IconButton';
import ExpandLess from '@material-ui/icons/ExpandLess';
import ExpandMore from '@material-ui/icons/ExpandMore';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import Button from '@material-ui/core/Button';
import { withLocalize } from "react-localize-redux";
import { withRouter } from 'react-router'

import {
  uiSetCurrentContainer,
  nodesFetchData,
  nodesFetchBatch,
} from '../../_actions/';
import { assetsFetchData } from '../../_actions/assets.actions';
import { fetchAllNodes } from '../../_actions/nodesAll.actions';

/* LOCAL */
import { SearchFilter } from '../SearchFilter';
import { CountrySwitcher } from '../CountrySwitcher';
import NodeContextMenu from '../NodeContextMenu';
import { AddNodeDialog, RenameNodeDialog, DeleteNodeDialog, PermissionsDialog, MoveNodeDialog, VisibilityScheduleDialog } from '../NodeDialogs';
import Tooltip from '@material-ui/core/Tooltip';
import { SnackBar } from '../SnackBar';
import { nodeService } from '../../_services/node.service';
import { userService } from '../../_services/user.service';
import { API_ENDPOINTS } from '../../config/api';

/* CSS */
import './style.css'

const menuStyle = theme => ({
  root: {
    width: '100%',
    backgroundColor: theme.palette.background.paper,
  },
  nested: {
    paddingLeft: theme.spacing.unit * 4,
  },
  listItem: {
    cursor: 'pointer',
    '&:hover': {
      backgroundColor: 'rgba(66, 33, 16, 0.66)',
    },
  },
  selectedItem: {
    // backgroundColor: 'rgba(0, 0, 0, 0.08) !important',
    backgroundColor: 'rgba(66, 33, 16, 0.88) !important',
  },
  back: {
    fontSize: '0.9em',
    paddingLeft: theme.spacing.unit * 2,
  }
});

const trunc = (str,n) => {
  return (str.length > n) ? str.substr(0, n-1) + '…' : str;
}

class Menu extends Component {
  constructor(props) {
    super(props);
    this.state = {
      contextMenu: null,
      selectedNode: null,
      addDialogOpen: false,
      renameDialogOpen: false,
      deleteDialogOpen: false,
      permissionsDialogOpen: false,
      moveDialogOpen: false,
      visibilityDialogOpen: false,
      userGroups: [],
      dragMode: false,
      snackbarOpen: false,
      snackbarMessage: '',
      snackbarVariant: 'success',
      draggedAssetId: null,
      draggedNodeId: null,
      dropTargetNodeId: null,
      targetParentNodeId: null,
      confirmMoveDialogOpen: false,
      expanded: [],
      loadingNodes: [],
      navigatingNodeId: null,
      sawNavigationLoading: false,
      _nodesAll: null,
    }
  }

  static getDerivedStateFromProps(nextProps, prevState) {
    const nextAll = nextProps.nodes && nextProps.nodes['all'];
    const prevAll = prevState._nodesAll;
    if (prevAll && nextAll && prevAll !== nextAll) {
      return { expanded: [], _nodesAll: nextAll };
    }
    if (prevAll !== nextAll) {
      return { _nodesAll: nextAll || null };
    }
    return null;
  }

  componentDidMount() {
    this.loadUserGroups();

    // Global handlers for AssetCard drag & drop
    window.menuHandleAssetDragStart = this.handleAssetDragStart;
    window.menuHandleAssetDragEnd = this.handleAssetDragEnd;

    // Restore expanded state from sessionStorage
    try {
      const saved = sessionStorage.getItem('menu_expanded');
      if (saved) {
        const expanded = JSON.parse(saved);
        if (Array.isArray(expanded) && expanded.length > 0) {
          this.setState({ expanded });
          // Only fetch nodes whose children are not already in the preloaded flat tree
          const allNodes = this.props.nodes['all'] || [];
          const toFetch = expanded.filter(nodeId => {
            if (nodeId === 'admin') return false;
            if (this.props.nodes[nodeId]) return false;
            return !allNodes.some(n => String(n.parentId) === nodeId);
          });
          if (toFetch.length === 1) {
            this.props.nodesFetchData(toFetch[0]);
          } else if (toFetch.length > 1) {
            this.props.nodesFetchBatch(toFetch);
          }
        }
      }
    } catch (e) { /* ignore */ }
  }

  componentWillUnmount() {
    delete window.menuHandleAssetDragStart;
    delete window.menuHandleAssetDragEnd;
  }

  componentDidUpdate(prevProps, prevState) {
    // On region switch, expanded is already cleared by getDerivedStateFromProps (before render).
    // Only handle the sessionStorage cleanup here.
    const prevAll = prevProps.nodes && prevProps.nodes['all'];
    const nextAll = this.props.nodes && this.props.nodes['all'];
    if (prevAll && nextAll && prevAll !== nextAll) {
      try { sessionStorage.removeItem('menu_expanded'); } catch (e) { /* ignore */ }
    }

    const { navigatingNodeId, sawNavigationLoading } = this.state;
    const isNodeLoading =
      this.props.nodesIsLoading ||
      this.props.assetIsLoading ||
      this.props.assetsIsLoading;

    if (!navigatingNodeId) {
      return;
    }

    if (isNodeLoading && !sawNavigationLoading) {
      this.setState({ sawNavigationLoading: true });
      return;
    }

    if (sawNavigationLoading && !isNodeLoading) {
      this.setState({
        navigatingNodeId: null,
        sawNavigationLoading: false,
      });
      return;
    }

    if (
      prevProps.location.pathname !== this.props.location.pathname &&
      prevState.navigatingNodeId &&
      !isNodeLoading
    ) {
      this.setState({
        navigatingNodeId: null,
        sawNavigationLoading: false,
      });
    }

    // Persist expanded state across page reloads
    if (prevState.expanded !== this.state.expanded) {
      try {
        sessionStorage.setItem('menu_expanded', JSON.stringify(this.state.expanded));
      } catch (e) { /* ignore */ }
    }
  }

  loadUserGroups = async () => {
    try {
      const response = await userService.getUserGroups(false);
      const data = response.data;
      this.setState({ userGroups: Array.isArray(data) ? data : (data && data.entities ? data.entities : []) });
    } catch (error) {
      console.error('Error loading user groups:', error);
    }
  };

  isAdmin = () => {
    const { authentication } = this.props;
    const user = authentication && authentication.user;
    return user && user.roles && Array.isArray(user.roles) && 
           user.roles.some(role => role.toUpperCase() === 'ADMIN');
  };

  // TreeView event handlers
  handleToggle = (event, nodeIds) => {
    if (!this.state.dragMode) {
      this.setState({ expanded: nodeIds });
    }
  };

  handleNodeClick = (nodeId) => {
    if (this.state.dragMode) return;
    
    this.setState({
      navigatingNodeId: String(nodeId),
      sawNavigationLoading: false,
    });
    this.props.uiSetCurrentContainer(nodeId);
    this.props.history.push(`/${nodeId}`);
  };

  handleNodeExpandAction = async (event, node) => {
    event.preventDefault();
    event.stopPropagation();

    if (this.state.dragMode) {
      return;
    }

    const nodeId = String(node.id);
    const existingBranch = this.props.nodes[nodeId];
    const allNodes = this.props.nodes['all'] || [];
    const childrenInAll = allNodes.some(n => String(n.parentId) === nodeId);

    if (node.hasChildren === true || existingBranch || childrenInAll) {
      this.handleToggleNode(nodeId);
      return;
    }

    // Prevent concurrent fetches for the same node
    if (this.state.loadingNodes.includes(nodeId)) return;

    this.setState(s => ({ loadingNodes: [...s.loadingNodes, nodeId] }));
    try {
      const loadedNode = await this.props.nodesFetchData(nodeId);
      if (loadedNode && ((loadedNode.children && loadedNode.children.length > 0) || loadedNode.hasChildren)) {
        this.handleToggleNode(nodeId);
      }
    } catch (error) {
      console.error('Error loading child nodes:', error);
    } finally {
      this.setState(s => ({ loadingNodes: s.loadingNodes.filter(id => id !== nodeId) }));
    }
  };
  handleContextMenu = (event, node) => {
    if (!this.isAdmin()) return;

    event.preventDefault();
    event.stopPropagation();
    
    this.setState({
      contextMenu: {
        mouseX: event.clientX - 2,
        mouseY: event.clientY - 4,
      },
      selectedNode: node
    });
  };

  handleContextMenuClose = () => {
    this.setState({ contextMenu: null });
  };

  handleAddNode = () => {
    this.setState({
      addDialogOpen: true,
      contextMenu: null
    });
  };

  handleRenameNode = () => {
    this.setState({
      renameDialogOpen: true,
      contextMenu: null
    });
  };

  handleMoveNode = () => {
    this.setState({
      moveDialogOpen: true,
      contextMenu: null
    });
  };

  handleConfirmMoveNode = async () => {
    const { draggedNodeId, targetParentNodeId } = this.state;
    
    try {
      await nodeService.moveNode(draggedNodeId, targetParentNodeId);
      
      // Kleine Verzögerung damit onClick nach Move nicht mehr feuert
      this.setState({
        confirmMoveDialogOpen: false,
        draggedNodeId: null,
        targetParentNodeId: null,
        snackbarOpen: true,
        snackbarMessage: 'Ordner erfolgreich verschoben!',
        snackbarVariant: 'success'
      });
      
      // dragMode erst nach kurzer Verzögerung zurücksetzen
      setTimeout(() => {
        this.setState({ dragMode: false });
      }, 100);
      
      // Reload all nodes to update entire menu tree
      this.props.fetchAllNodes(localStorage.getItem('regionId'));
    } catch (error) {
      console.error('Error moving node:', error);
      this.setState({
        confirmMoveDialogOpen: false,
        draggedNodeId: null,
        targetParentNodeId: null,
        dragMode: false,
        snackbarOpen: true,
        snackbarMessage: 'Fehler beim Verschieben: ' + (error.message || 'Unknown error'),
        snackbarVariant: 'error'
      });
    }
  };

  handleCancelMoveNode = () => {
    this.setState({
      confirmMoveDialogOpen: false,
      draggedNodeId: null,
      targetParentNodeId: null,
      dragMode: false,
    });
  };

  handleMoveNodeSubmit = async (data) => {
    try {
      const { selectedNode } = this.state;
      await nodeService.moveNode(selectedNode.id, data.newParentId);
      this.setState({ 
        moveDialogOpen: false, 
        selectedNode: null,
        snackbarOpen: true,
        snackbarMessage: 'Ordner erfolgreich verschoben!',
        snackbarVariant: 'success'
      });
      // Reload nodes without page reload
      const currentContainerId = this.props.container && this.props.container.id ? this.props.container.id : this.props.rootId;
      if (currentContainerId && currentContainerId !== 'all') {
        this.props.nodesFetchData(currentContainerId);
      }
    } catch (error) {
      console.error('Error moving node:', error);
      const errorMessage = (error.response && error.response.data && error.response.data.message) || error.message;
      alert(`Fehler beim Verschieben des Ordners: ${errorMessage}`);
    }
  };

  handleDeleteNode = () => {
    this.setState({
      deleteDialogOpen: true,
      contextMenu: null
    });
  };

  handlePermissions = () => {
    this.setState({
      permissionsDialogOpen: true,
      contextMenu: null
    });
  };

  getRegionIdFromCountry = (country, regions) => {
    if (!regions || regions.length === 0) {
      // Fallback: try to get from localStorage
      const storedRegionId = localStorage.getItem('regionId');
      if (storedRegionId) return storedRegionId;
      return null;
    }
    
    // Map country flag identifier to region name
    const getRegionName = (countryFlag) => {
      if (countryFlag === 'germany') return 'deutschland';
      if (countryFlag === 'austria') return 'österreich';
      if (countryFlag === 'switzerland') return 'schweiz';
      return countryFlag;
    };
    
    const searchName = getRegionName(country).toLowerCase();
    
    // Find region by matching name
    const region = regions.find(r => {
      if (!r.names) return false;
      return r.names.some(n => 
        n.value && n.value.toLowerCase().includes(searchName)
      );
    });
    
    if (region && region.id) {
      // Store regionId in localStorage
      localStorage.setItem('regionId', region.id);
      return region.id;
    }
    
    // Fallback: use first region if no match found
    if (regions.length > 0 && regions[0].id) {
      localStorage.setItem('regionId', regions[0].id);
      return regions[0].id;
    }
    
    return null;
  };

  // Asset Drag & Drop handlers
  handleAssetDragStart = (assetId) => {
    if (!this.isAdmin()) return;
    
    this.setState({ 
      draggedAssetId: assetId,
      dragMode: true 
    });
  };

  handleAssetDragEnd = () => {
    this.setState({ 
      draggedAssetId: null,
      dropTargetNodeId: null,
      dragMode: false
    });
  };

  handleNodeDragOver = (e, nodeId) => {
    if (!this.isAdmin()) return;
    
    const { draggedAssetId, draggedNodeId } = this.state;
    
    // Nur wenn etwas gedragged wird
    if (!draggedAssetId && !draggedNodeId) return;
    
    // Bei Node-Drag: Verhindern, dass ein Node auf sich selbst gedroppt wird
    if (draggedNodeId && draggedNodeId === nodeId) {
      e.dataTransfer.dropEffect = 'none';
      return;
    }
    
    e.preventDefault();
    e.stopPropagation();
    e.dataTransfer.dropEffect = 'move';
    
    this.setState({ dropTargetNodeId: nodeId });
  };

  handleNodeDragLeave = (e, nodeId) => {
    e.preventDefault();
    
    if (this.state.dropTargetNodeId === nodeId) {
      this.setState({ dropTargetNodeId: null });
    }
  };

  handleNodeDrop = async (e, nodeId) => {
    e.preventDefault();
    e.stopPropagation();
    
    const { draggedAssetId, draggedNodeId } = this.state;
    
    // Handle Node Drop
    if (this.isAdmin() && draggedNodeId) {
      // Prevent dropping a node onto itself
      if (draggedNodeId === nodeId) {
        this.setState({ 
          draggedNodeId: null, 
          dropTargetNodeId: null,
          dragMode: false 
        });
        return;
      }
      
      // Speichere die draggedNodeId, bevor onDragEnd sie löscht
      // Show confirmation dialog with both IDs
      this.setState({
        draggedNodeId: draggedNodeId, // Explizit erneut setzen, damit es nicht von onDragEnd gelöscht wird
        targetParentNodeId: nodeId,
        confirmMoveDialogOpen: true,
        dropTargetNodeId: null,
      });
      return;
    }
    
    // Handle Asset Drop
    if (!this.isAdmin() || !draggedAssetId) {
      this.setState({ 
        draggedAssetId: null, 
        dropTargetNodeId: null,
        dragMode: false 
      });
      return;
    }

    try {
      await this.moveAssetToNode(draggedAssetId, nodeId);
      
      this.setState({ 
        draggedAssetId: null,
        dropTargetNodeId: null,
        dragMode: false,
        snackbarOpen: true,
        snackbarMessage: 'Asset erfolgreich verschoben!',
        snackbarVariant: 'success'
      });
      
      // Reload assets for current container without page reload
      const { container } = this.props;
      if (container) {
        this.props.assetsFetchData(container);
      }
    } catch (error) {
      console.error('Error moving asset:', error);
      this.setState({ 
        draggedAssetId: null,
        dropTargetNodeId: null,
        dragMode: false,
        snackbarOpen: true,
        snackbarMessage: 'Fehler beim Verschieben: ' + (error.message || 'Unknown error'),
        snackbarVariant: 'error'
      });
    }
  };

  moveAssetToNode = async (assetId, nodeId) => {
    const user = JSON.parse(localStorage.getItem('user'));
    const headers = {
      'Accept': 'application/json',
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${user.token}`
    };

    const response = await fetch(`${API_ENDPOINTS.ASSETS.BY_ID(assetId)}`, {
      method: 'PATCH',
      headers,
      body: JSON.stringify({ nodeId })
    });

    if (!response.ok) {
      const error = await response.json();
      throw new Error(error.message || 'Failed to move asset');
    }

    return response.json();
  };

  handleAddNodeSubmit = async (data) => {
    try {
      const { selectedNode } = this.state;
      const { country, regions } = this.props;
      
      // Get regionId from country
      const regionId = this.getRegionIdFromCountry(country, regions);
      
      if (!regionId) {
        alert('Fehler: Keine Region gefunden. Bitte wählen Sie ein Land aus.');
        return;
      }
      
      // Add regionId and active to data
      const nodeData = {
        ...data,
        regionId,
        active: true
      };
      
      await nodeService.createNode(selectedNode.id, nodeData);
      this.setState({ 
        addDialogOpen: false, 
        selectedNode: null,
        snackbarOpen: true,
        snackbarMessage: 'Ordner erfolgreich hinzugefügt!',
        snackbarVariant: 'success'
      });
      // Reload all nodes to update entire menu tree
      this.props.fetchAllNodes(localStorage.getItem('regionId'));
    } catch (error) {
      console.error('Error adding node:', error);
      const errorMessage = (error.response && error.response.data && error.response.data.message) || error.message;
      alert(`Fehler beim Hinzufügen des Ordners: ${errorMessage}`);
    }
  };

  handleRenameNodeSubmit = async (data) => {
    try {
      const { selectedNode } = this.state;
      await nodeService.updateNode(selectedNode.id, data);
      this.setState({ 
        renameDialogOpen: false, 
        selectedNode: null,
        snackbarOpen: true,
        snackbarMessage: 'Ordner erfolgreich umbenannt!',
        snackbarVariant: 'success'
      });
      // Reload all nodes to update entire menu tree
      this.props.fetchAllNodes(localStorage.getItem('regionId'));
    } catch (error) {
      console.error('Error renaming node:', error);
      const errorMessage = (error.response && error.response.data && error.response.data.message) || error.message;
      alert(`Fehler beim Umbenennen des Ordners: ${errorMessage}`);
    }
  };

  handleDeleteNodeConfirm = async () => {
    try {
      const { selectedNode } = this.state;
      await nodeService.deleteNode(selectedNode.id);
      this.setState({ 
        deleteDialogOpen: false, 
        selectedNode: null,
        snackbarOpen: true,
        snackbarMessage: 'Ordner erfolgreich gelöscht!',
        snackbarVariant: 'success'
      });
      // Reload all nodes to update entire menu tree
      this.props.fetchAllNodes(localStorage.getItem('regionId'));
    } catch (error) {
      console.error('Error deleting node:', error);
      const errorMessage = (error.response && error.response.data && error.response.data.message) || error.message;
      alert(`Fehler beim Löschen des Ordners: ${errorMessage}`);
    }
  };

  handlePermissionsSubmit = async (data) => {
    try {
      const { selectedNode } = this.state;
      await nodeService.updatePermissions(selectedNode.id, data);
      this.setState({ 
        permissionsDialogOpen: false, 
        selectedNode: null,
        snackbarOpen: true,
        snackbarMessage: 'Berechtigungen erfolgreich aktualisiert!',
        snackbarVariant: 'success'
      });
      // Reload all nodes to update entire menu tree
      this.props.fetchAllNodes(localStorage.getItem('regionId'));
    } catch (error) {
      console.error('Error updating permissions:', error);
      const errorMessage = (error.response && error.response.data && error.response.data.message) || error.message;
      alert(`Fehler beim Aktualisieren der Berechtigungen: ${errorMessage}`);
    }
  };

  handleSnackbarClose = () => {
    this.setState({ snackbarOpen: false });
  };

  handleVisibility = () => {
    this.setState({ visibilityDialogOpen: true, contextMenu: null });
  };

  handleVisibilitySubmit = async (data) => {
    try {
      const { selectedNode } = this.state;
      await nodeService.updateNode(selectedNode.id, data);
      this.setState({
        visibilityDialogOpen: false,
        selectedNode: null,
        snackbarOpen: true,
        snackbarMessage: 'Sichtbarkeit erfolgreich gespeichert!',
        snackbarVariant: 'success'
      });
      this.props.fetchAllNodes(localStorage.getItem('regionId'));
    } catch (error) {
      console.error('Error updating visibility:', error);
      const errorMessage = (error.response && error.response.data && error.response.data.message) || error.message;
      alert(`Fehler beim Speichern der Sichtbarkeit: ${errorMessage}`);
    }
  };

  // Render a tree node with collapse functionality
  renderTreeNode = (node, lang, depth = 0) => {
    const { classes, container, nodes } = this.props;
    const { dropTargetNodeId, dragMode, expanded, navigatingNodeId, loadingNodes } = this.state;
    const isAdmin = this.isAdmin();
    
    const nameEntry = node.names && node.names.find(n => n.lang === lang.toUpperCase());
    const fallbackEntry = node.names && node.names.find(n => n.lang === 'DE');
    const nodeName = nameEntry ? nameEntry.value : (fallbackEntry ? fallbackEntry.value : '');
    
    const hasNumberPrefix = nodeName.match(/#?([0-9]{3})\s/);
    const truncateLength = hasNumberPrefix ? 30 : 25;
    let label = trunc(nodeName.replace(/#?([0-9]{3})\s/, ''), truncateLength);

    const now = new Date();
    const isRestricted = node.visibilityFrom && new Date(node.visibilityFrom) > now;
    const restrictedGroupName = isRestricted && node.restrictedGroup && node.restrictedGroup.names
      ? ((node.restrictedGroup.names.find(n => n.lang === 'DE') || node.restrictedGroup.names[0]) || {}).value || ''
      : '';
    const tooltipTitle = isRestricted
      ? `Nur für${restrictedGroupName ? ` „${restrictedGroupName}"` : ' eingeschränkte Gruppe'} sichtbar bis ${new Date(node.visibilityFrom).toLocaleDateString('de-DE')}`
      : '';
    const labelNode = (
      <span style={{ fontStyle: isRestricted ? 'italic' : 'normal' }}>{label}</span>
    );
    const labelDisplay = isRestricted ? (
      <Tooltip title={tooltipTitle} placement="right">{labelNode}</Tooltip>
    ) : labelNode;

    const branchNodes = nodes[node.id];
    const hasFetchedBranch = branchNodes !== undefined;
    const allNodes = nodes['all'] || [];
    const children = hasFetchedBranch
      ? branchNodes.filter(candidate => candidate.id !== node.id && candidate.parentId === node.id)
      : allNodes.filter(candidate => String(candidate.parentId) === String(node.id));
    // Show expand arrow if: hasChildren is explicitly set, or branch not yet loaded (optimistic), or loaded children exist
    const hasChildren = node.hasChildren != null
      ? !!node.hasChildren
      : (!hasFetchedBranch || children.length > 0);
    
    const isExpanded = expanded.includes(String(node.id));
    const isSelected = String(container) === String(node.id);
    const isNavigating = String(navigatingNodeId) === String(node.id);
    const isDropTarget = isAdmin && dropTargetNodeId === node.id;

    return (
      <React.Fragment key={node.id}>
        <ListItem
          button
          dense
          draggable={isAdmin}
          className={`${classes.listItem} ${isSelected ? classes.selectedItem : ''}`}
          style={{
            paddingLeft: 8 + depth * 16,
            backgroundColor: isDropTarget ? '#e3f2fd' : 'transparent',
            borderLeft: isDropTarget ? '4px solid #2196f3' : 'none',
            transition: 'background-color 0.2s, border-left 0.2s',
            cursor: dragMode ? 'default' : 'pointer',
          }}
          onDragStart={isAdmin ? (e) => {
            e.stopPropagation();
            e.dataTransfer.effectAllowed = 'move';
            e.dataTransfer.setData('nodeId', node.id);
            this.setState({ 
              draggedNodeId: node.id,
              dragMode: true 
            });
          } : undefined}
          onDragEnd={isAdmin ? () => {
            // Nur State clearen wenn kein Confirmation-Dialog offen ist
            if (!this.state.confirmMoveDialogOpen) {
              // Kleine Verzögerung damit onClick nach Drop nicht mehr feuert
              setTimeout(() => {
                this.setState({ 
                  draggedNodeId: null,
                  dropTargetNodeId: null,
                  dragMode: false
                });
              }, 100);
            }
          } : undefined}
          onContextMenu={isAdmin ? (e) => this.handleContextMenu(e, node) : undefined}
          onDragOver={isAdmin ? (e) => {
            if (this.state.draggedNodeId || this.state.draggedAssetId) {
              this.handleNodeDragOver(e, node.id);
            }
          } : undefined}
          onDragLeave={isAdmin ? (e) => this.handleNodeDragLeave(e, node.id) : undefined}
          onDrop={isAdmin ? (e) => this.handleNodeDrop(e, node.id) : undefined}
          onClick={(e) => {
            if (hasChildren) this.handleNodeExpandAction(e, node);
            this.handleNodeClick(node.id);
          }}
        >
          <ListItemText 
            primary={labelDisplay}
            primaryTypographyProps={{
              style: { 
                fontSize: '0.9rem',
                color: isSelected ? '#fff' : 'inherit'
              }
            }}
          />
          {isNavigating && (
            <CircularProgress
              size={16}
              thickness={5}
              style={{ marginRight: hasChildren ? 4 : 0, color: isSelected ? '#fff' : 'inherit' }}
            />
          )}
          {hasChildren && (
            <IconButton
              size="small"
              disabled={loadingNodes.includes(String(node.id))}
              onClick={(event) => this.handleNodeExpandAction(event, node)}
              style={{
                padding: 4,
                marginRight: -4,
                color: isSelected ? '#fff' : 'inherit',
              }}
            >
              {loadingNodes.includes(String(node.id))
                ? <CircularProgress size={16} thickness={5} style={{ color: isSelected ? '#fff' : 'inherit' }} />
                : isExpanded ? <ExpandLess /> : <ExpandMore />
              }
            </IconButton>
          )}
        </ListItem>
        
        {hasChildren && (
          <Collapse in={isExpanded} timeout="auto">
            <List component="div" disablePadding>
              {children.map(child => this.renderTreeNode(child, lang, depth + 1))}
            </List>
          </Collapse>
        )}
      </React.Fragment>
    );
  };

  handleToggleNode = (nodeId) => {
    const { expanded } = this.state;
    const nodeIdStr = String(nodeId);

    if (expanded.includes(nodeIdStr)) {
      this.setState({ expanded: expanded.filter(id => id !== nodeIdStr) });
    } else {
      if (!this.props.nodes[nodeId]) {
        const allNodes = this.props.nodes['all'] || [];
        const hasChildrenInAll = allNodes.some(n => String(n.parentId) === nodeIdStr);
        if (!hasChildrenInAll) {
          this.props.nodesFetchData(nodeId);
        }
      }
      this.setState({ expanded: [...expanded, nodeIdStr] });
    }
  };

  render() {
    const { classes, nodes, nodesIsLoading, searchActive, lang, rootId } = this.props;
    const { pathname } = this.props.location;
    
    const isAdmin = this.isAdmin();

    if (nodesIsLoading && (!nodes || !nodes[rootId] || nodes[rootId].length === 0)) {
      return (
        <div style={{ display: 'flex', justifyContent: 'center', paddingTop: 40 }}>
          <CircularProgress />
        </div>
      );
    }

    if (pathname.indexOf("/order") >= 0) {
      return (
        <div>
          <Link to="/" className={classes.back}>Zurück</Link>
          <Divider/>
          <List className={classes.root}>
            <ListItem button onClick={() => this.props.history.push('/orders')}>
              <ListItemText primary="Aktuelle Aufträge" />
            </ListItem>
            <ListItem button onClick={() => this.props.history.push('/order/add')}>
              <ListItemText primary="Auftrag erstellen" />
            </ListItem>
          </List>
        </div>
      );
    }

    if (!nodes || !nodes[rootId]) {
      return null;
    }

    const allRootCandidates = nodes['all'] || [];
    const rootCandidateIds = new Set(allRootCandidates.map((node) => String(node.id)));
    const rootNodes = allRootCandidates.filter((node) => {
      if (!node || !node.id) {
        return false;
      }

      return !node.parentId || !rootCandidateIds.has(String(node.parentId));
    }).sort((a, b) => {
      // Sort alphabetically by name
      const aName = a.names && a.names[0] ? a.names[0].value : '';
      const bName = b.names && b.names[0] ? b.names[0].value : '';
      return aName.localeCompare(bName);
    });
    const availableNodes = Array.from(
      Object.values(nodes)
        .flat()
        .reduce((acc, node) => {
          if (node && node.id) {
            acc.set(node.id, node);
          }
          return acc;
        }, new Map())
        .values(),
    );
    
    const { expanded } = this.state;
    
    return (
      <div>
        <CountrySwitcher {...this.props} />
        
        <List className={classes.root}>
          {rootNodes.map(node => this.renderTreeNode(node, lang, 0))}
        </List>

        {searchActive && (
          <div>
            <Divider/>
            <SearchFilter/>
          </div>
        )}

        {isAdmin && (
          <div>
            <Divider style={{marginTop: '16px'}} />
            <List className={classes.root}>
              <ListItem
                button
                onClick={() => this.handleToggleNode('admin')}
              >
                <ListItemText primary="Administration" />
                {expanded.includes('admin') ? <ExpandLess /> : <ExpandMore />}
              </ListItem>
              <Collapse in={expanded.includes('admin')} timeout="auto">
                <List component="div" disablePadding>
                  <ListItem 
                    button 
                    className={classes.nested}
                    onClick={() => this.props.history.push('/manage/users')}
                  >
                    <ListItemText primary="Benutzerverwaltung" primaryTypographyProps={{ style: { fontSize: '0.9rem' } }} />
                  </ListItem>
                  <ListItem
                    button
                    className={classes.nested}
                    onClick={() => this.props.history.push('/manage/registrations')}
                  >
                    <ListItemText primary="Registrierungen" primaryTypographyProps={{ style: { fontSize: '0.9rem' } }} />
                  </ListItem>
                  <ListItem
                    button
                    className={classes.nested}
                    onClick={() => this.props.history.push('/manage/unconfirmed-emails')}
                  >
                    <ListItemText primary="Unbestätigte E-Mails" primaryTypographyProps={{ style: { fontSize: '0.9rem' } }} />
                  </ListItem>
                  <ListItem
                    button
                    className={classes.nested}
                    onClick={() => this.props.history.push('/manage/metadata')}
                  >
                    <ListItemText primary="Metadatenfelder" primaryTypographyProps={{ style: { fontSize: '0.9rem' } }} />
                  </ListItem>
                  <ListItem
                    button
                    className={classes.nested}
                    onClick={() => this.props.history.push('/manage/translations')}
                  >
                    <ListItemText primary="Übersetzungen" primaryTypographyProps={{ style: { fontSize: '0.9rem' } }} />
                  </ListItem>
                  <ListItem
                    button
                    className={classes.nested}
                    onClick={() => this.props.history.push('/manage/asset-stats')}
                  >
                    <ListItemText primary="Asset-Statistiken" primaryTypographyProps={{ style: { fontSize: '0.9rem' } }} />
                  </ListItem>
                  <ListItem
                    button
                    className={classes.nested}
                    onClick={() => this.props.history.push('/manage/settings')}
                  >
                    <ListItemText primary="Einstellungen" primaryTypographyProps={{ style: { fontSize: '0.9rem' } }} />
                  </ListItem>
                </List>
              </Collapse>
            </List>
          </div>
        )}
        
        {/* Context Menu & Dialogs for Admins */}
        {isAdmin && (
          <>
            <NodeContextMenu
              anchorEl={this.state.contextMenu}
              onClose={this.handleContextMenuClose}
              onAdd={this.handleAddNode}
              onRename={this.handleRenameNode}
              onMove={this.handleMoveNode}
              onDelete={this.handleDeleteNode}
              onPermissions={this.handlePermissions}
              onVisibility={this.handleVisibility}
            />
            
            <AddNodeDialog
              open={this.state.addDialogOpen}
              onClose={() => this.setState({ addDialogOpen: false })}
              onSubmit={this.handleAddNodeSubmit}
              userGroups={this.state.userGroups}
            />
            
            <RenameNodeDialog
              open={this.state.renameDialogOpen}
              onClose={() => this.setState({ renameDialogOpen: false })}
              onSubmit={this.handleRenameNodeSubmit}
              node={this.state.selectedNode}
            />
            
            <DeleteNodeDialog
              open={this.state.deleteDialogOpen}
              onClose={() => this.setState({ deleteDialogOpen: false })}
              onConfirm={this.handleDeleteNodeConfirm}
              node={this.state.selectedNode}
            />
            
            <PermissionsDialog
              open={this.state.permissionsDialogOpen}
              onClose={() => this.setState({ permissionsDialogOpen: false })}
              onSubmit={this.handlePermissionsSubmit}
              node={this.state.selectedNode}
              userGroups={this.state.userGroups}
            />
            
            <MoveNodeDialog
              open={this.state.moveDialogOpen}
              onClose={() => this.setState({ moveDialogOpen: false })}
              onSubmit={this.handleMoveNodeSubmit}
              node={this.state.selectedNode}
              availableNodes={availableNodes.filter(n => n.id !== (this.state.selectedNode && this.state.selectedNode.id))}
              lang={lang}
            />

            <VisibilityScheduleDialog
              open={this.state.visibilityDialogOpen}
              onClose={() => this.setState({ visibilityDialogOpen: false })}
              onSubmit={this.handleVisibilitySubmit}
              node={this.state.selectedNode}
              userGroups={this.state.userGroups}
            />
            
            {/* Confirmation Dialog for Node Drag & Drop */}
            <Dialog
              open={this.state.confirmMoveDialogOpen}
              onClose={this.handleCancelMoveNode}
            >
              <DialogTitle>Ordner verschieben</DialogTitle>
              <DialogContent>
                <DialogContentText>
                  Möchten Sie diesen Ordner wirklich verschieben?
                </DialogContentText>
              </DialogContent>
              <DialogActions>
                <Button onClick={this.handleCancelMoveNode} color="primary">
                  Abbrechen
                </Button>
                <Button onClick={this.handleConfirmMoveNode} color="primary" autoFocus>
                  Verschieben
                </Button>
              </DialogActions>
            </Dialog>
          </>
        )}

        <SnackBar
          open={this.state.snackbarOpen}
          variant={this.state.snackbarVariant}
          message={this.state.snackbarMessage}
          onClose={this.handleSnackbarClose}
        />
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    nodes: state.nodes,
    asset: state.asset,
    container: state.container,
    nodesIsLoading: state.nodesIsLoading,
    assetIsLoading: state.assetIsLoading,
    assetsIsLoading: state.assetsIsLoading,
    nodesHasErrored: state.nodesHasErrored,
    authentication: state.authentication,
    searchActive: state.searchActive,
    search: state.search,
    lang: state.lang,
    country: state.country,
    rootId: state.rootId,
    regions: state.regions,
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    uiSetCurrentContainer: (id) => dispatch(uiSetCurrentContainer(id)),
    nodesFetchData: (id) => dispatch(nodesFetchData(id)),
    nodesFetchBatch: (ids) => dispatch(nodesFetchBatch(ids)),
    assetsFetchData: (id) => dispatch(assetsFetchData(id)),
    fetchAllNodes: (regionId) => dispatch(fetchAllNodes(regionId)),
  };
};

export default withRouter(withLocalize(connect(mapStateToProps, mapDispatchToProps)(withStyles(menuStyle)(Menu))));
